import { render } from "./register-stepper-contact.vue?vue&type=template&id=47cb9a2c&scoped=true&ts=true"
import script from "./register-stepper-contact.vue?vue&type=script&lang=ts"
export * from "./register-stepper-contact.vue?vue&type=script&lang=ts"

import "./register-stepper-contact.vue?vue&type=style&index=0&id=47cb9a2c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47cb9a2c"]])

export default __exports__